import { MetricType } from './types';

export const TEST_DATA: Record<MetricType, string> = {
  throughput: '5,7,3,5,22,6',
  velocity: '13,21,8,13,55,16'
};

export const SIMULATION_CONFIG = {
  SIMULATIONS: 1000,
  MAX_SPRINTS: 50,
  VARIATION_PERCENTAGE: 0.2 // ±10%
} as const;

export const CONFIDENCE_LEVELS = {
  P50: 0.5,
  P85: 0.85,
  P95: 0.95
} as const;
